/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { ComplianceFormRequest } from '../models';
import { EeReportBreachRequest } from '../models';
import { EeReportBreachResponse } from '../models';
import { EeReportControlledMoneyRequest } from '../models';
import { EeReportControlledMoneyResponse } from '../models';
import { EeReportDeclarationRequest } from '../models';
import { EeReportDeclarationResponse } from '../models';
import { EeReportGeneralTrustMoneyRequest } from '../models';
import { EeReportGeneralTrustMoneyResponse } from '../models';
import { EeReportInvestmentMoneyRequest } from '../models';
import { EeReportInvestmentMoneyResponse } from '../models';
import { EeReportOtherInformationRequest } from '../models';
import { EeReportOtherInformationResponse } from '../models';
import { EeReportOverviewResponse } from '../models';
import { EeReportSpecificPowerMoneyRequest } from '../models';
import { EeReportSpecificPowerMoneyResponse } from '../models';
import { EeReportSubmitRequest } from '../models';
import { FormStatusResponse } from '../models';
import { PartBResubmissionRequestRequestForEe } from '../models';
/**
 * EeReportApi - axios parameter creator
 * @export
 */
export const EeReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary External Examiner | Returns true when a form is successfully closed
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportClosePost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/Close`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Extend the current Form Status
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportExtendFormStatusPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/ExtendFormStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Breaches
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetBreachesPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/GetBreaches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Controlled Money
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetControlledMoneyPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/GetControlledMoney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Declaration
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetDeclarationPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/GetDeclaration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetFormStatusComplianceFormIdGet: async (complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2EeReportGetFormStatusComplianceFormIdGet.');
            }
            const localVarPath = `/api/v2/EeReport/GetFormStatus/{complianceFormId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - General Trust Money
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetGeneralTrustMoneyPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/GetGeneralTrustMoney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Investment Money
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetInvestmentMoneyPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/GetInvestmentMoney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Other Information
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetOtherInformationPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/GetOtherInformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Overview
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetOverviewPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/GetOverview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Specific Power Money
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetSpecificPowerMoneyPost: async (body?: ComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/GetSpecificPowerMoney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Kick out the current Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportKickOutFormStatusComplianceFormIdGet: async (complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2EeReportKickOutFormStatusComplianceFormIdGet.');
            }
            const localVarPath = `/api/v2/EeReport/KickOutFormStatus/{complianceFormId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - Breaches
         * @param {EeReportBreachRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSaveBreachesPost: async (body?: EeReportBreachRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/SaveBreaches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - General Controlled Money Responses
         * @param {EeReportControlledMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSaveControlledMoneyPost: async (body?: EeReportControlledMoneyRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/SaveControlledMoney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - Declaration
         * @param {EeReportDeclarationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSaveDeclarationPost: async (body?: EeReportDeclarationRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/SaveDeclaration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - General Trust Money Responses
         * @param {EeReportGeneralTrustMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSaveGeneralTrustMoneyPost: async (body?: EeReportGeneralTrustMoneyRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/SaveGeneralTrustMoney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - General Controlled Money Responses
         * @param {EeReportInvestmentMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSaveInvestmentMoneyPost: async (body?: EeReportInvestmentMoneyRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/SaveInvestmentMoney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - Other Information Responses
         * @param {EeReportOtherInformationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSaveOtherInformationPost: async (body?: EeReportOtherInformationRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/SaveOtherInformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Save PartB Resubmission Request
         * @param {PartBResubmissionRequestRequestForEe} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSavePartBResubmissionRequestPost: async (body?: PartBResubmissionRequestRequestForEe, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/SavePartBResubmissionRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - Specific Power Money Responses
         * @param {EeReportSpecificPowerMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSaveSpecificPowerMoneyPost: async (body?: EeReportSpecificPowerMoneyRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/SaveSpecificPowerMoney`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary External Examiner | Submit External Examiner Report
         * @param {EeReportSubmitRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSubmitEeReportPost: async (body?: EeReportSubmitRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/EeReport/SubmitEeReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EeReportApi - functional programming interface
 * @export
 */
export const EeReportApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary External Examiner | Returns true when a form is successfully closed
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportClosePost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportClosePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Extend the current Form Status
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportExtendFormStatusPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportExtendFormStatusPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Breaches
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportGetBreachesPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeReportBreachResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportGetBreachesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Controlled Money
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportGetControlledMoneyPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeReportControlledMoneyResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportGetControlledMoneyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Declaration
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportGetDeclarationPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeReportDeclarationResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportGetDeclarationPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportGetFormStatusComplianceFormIdGet(complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormStatusResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportGetFormStatusComplianceFormIdGet(complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - General Trust Money
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportGetGeneralTrustMoneyPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeReportGeneralTrustMoneyResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportGetGeneralTrustMoneyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Investment Money
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportGetInvestmentMoneyPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeReportInvestmentMoneyResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportGetInvestmentMoneyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Other Information
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportGetOtherInformationPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeReportOtherInformationResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportGetOtherInformationPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Overview
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportGetOverviewPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeReportOverviewResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportGetOverviewPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Specific Power Money
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportGetSpecificPowerMoneyPost(body?: ComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeReportSpecificPowerMoneyResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportGetSpecificPowerMoneyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Kick out the current Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportKickOutFormStatusComplianceFormIdGet(complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportKickOutFormStatusComplianceFormIdGet(complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - Breaches
         * @param {EeReportBreachRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportSaveBreachesPost(body?: EeReportBreachRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportSaveBreachesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - General Controlled Money Responses
         * @param {EeReportControlledMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportSaveControlledMoneyPost(body?: EeReportControlledMoneyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportSaveControlledMoneyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - Declaration
         * @param {EeReportDeclarationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportSaveDeclarationPost(body?: EeReportDeclarationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportSaveDeclarationPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - General Trust Money Responses
         * @param {EeReportGeneralTrustMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportSaveGeneralTrustMoneyPost(body?: EeReportGeneralTrustMoneyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportSaveGeneralTrustMoneyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - General Controlled Money Responses
         * @param {EeReportInvestmentMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportSaveInvestmentMoneyPost(body?: EeReportInvestmentMoneyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportSaveInvestmentMoneyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - Other Information Responses
         * @param {EeReportOtherInformationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportSaveOtherInformationPost(body?: EeReportOtherInformationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportSaveOtherInformationPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Save PartB Resubmission Request
         * @param {PartBResubmissionRequestRequestForEe} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportSavePartBResubmissionRequestPost(body?: PartBResubmissionRequestRequestForEe, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportSavePartBResubmissionRequestPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - Specific Power Money Responses
         * @param {EeReportSpecificPowerMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportSaveSpecificPowerMoneyPost(body?: EeReportSpecificPowerMoneyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportSaveSpecificPowerMoneyPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary External Examiner | Submit External Examiner Report
         * @param {EeReportSubmitRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EeReportSubmitEeReportPost(body?: EeReportSubmitRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await EeReportApiAxiosParamCreator(configuration).apiV2EeReportSubmitEeReportPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EeReportApi - factory interface
 * @export
 */
export const EeReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary External Examiner | Returns true when a form is successfully closed
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportClosePost(body?: ComplianceFormRequest, options?: any): AxiosPromise<BooleanResponse> {
            return EeReportApiFp(configuration).apiV2EeReportClosePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Extend the current Form Status
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportExtendFormStatusPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<BooleanResponse> {
            return EeReportApiFp(configuration).apiV2EeReportExtendFormStatusPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Breaches
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetBreachesPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<EeReportBreachResponse> {
            return EeReportApiFp(configuration).apiV2EeReportGetBreachesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Controlled Money
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetControlledMoneyPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<EeReportControlledMoneyResponse> {
            return EeReportApiFp(configuration).apiV2EeReportGetControlledMoneyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Declaration
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetDeclarationPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<EeReportDeclarationResponse> {
            return EeReportApiFp(configuration).apiV2EeReportGetDeclarationPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetFormStatusComplianceFormIdGet(complianceFormId: number, options?: any): AxiosPromise<FormStatusResponse> {
            return EeReportApiFp(configuration).apiV2EeReportGetFormStatusComplianceFormIdGet(complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - General Trust Money
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetGeneralTrustMoneyPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<EeReportGeneralTrustMoneyResponse> {
            return EeReportApiFp(configuration).apiV2EeReportGetGeneralTrustMoneyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Investment Money
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetInvestmentMoneyPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<EeReportInvestmentMoneyResponse> {
            return EeReportApiFp(configuration).apiV2EeReportGetInvestmentMoneyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Other Information
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetOtherInformationPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<EeReportOtherInformationResponse> {
            return EeReportApiFp(configuration).apiV2EeReportGetOtherInformationPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Overview
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetOverviewPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<EeReportOverviewResponse> {
            return EeReportApiFp(configuration).apiV2EeReportGetOverviewPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Returns EE Report - Specific Power Money
         * @param {ComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportGetSpecificPowerMoneyPost(body?: ComplianceFormRequest, options?: any): AxiosPromise<EeReportSpecificPowerMoneyResponse> {
            return EeReportApiFp(configuration).apiV2EeReportGetSpecificPowerMoneyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact  | Kick out the current Form Status
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportKickOutFormStatusComplianceFormIdGet(complianceFormId: number, options?: any): AxiosPromise<BooleanResponse> {
            return EeReportApiFp(configuration).apiV2EeReportKickOutFormStatusComplianceFormIdGet(complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - Breaches
         * @param {EeReportBreachRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSaveBreachesPost(body?: EeReportBreachRequest, options?: any): AxiosPromise<BooleanResponse> {
            return EeReportApiFp(configuration).apiV2EeReportSaveBreachesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - General Controlled Money Responses
         * @param {EeReportControlledMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSaveControlledMoneyPost(body?: EeReportControlledMoneyRequest, options?: any): AxiosPromise<BooleanResponse> {
            return EeReportApiFp(configuration).apiV2EeReportSaveControlledMoneyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - Declaration
         * @param {EeReportDeclarationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSaveDeclarationPost(body?: EeReportDeclarationRequest, options?: any): AxiosPromise<BooleanResponse> {
            return EeReportApiFp(configuration).apiV2EeReportSaveDeclarationPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - General Trust Money Responses
         * @param {EeReportGeneralTrustMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSaveGeneralTrustMoneyPost(body?: EeReportGeneralTrustMoneyRequest, options?: any): AxiosPromise<BooleanResponse> {
            return EeReportApiFp(configuration).apiV2EeReportSaveGeneralTrustMoneyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - General Controlled Money Responses
         * @param {EeReportInvestmentMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSaveInvestmentMoneyPost(body?: EeReportInvestmentMoneyRequest, options?: any): AxiosPromise<BooleanResponse> {
            return EeReportApiFp(configuration).apiV2EeReportSaveInvestmentMoneyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - Other Information Responses
         * @param {EeReportOtherInformationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSaveOtherInformationPost(body?: EeReportOtherInformationRequest, options?: any): AxiosPromise<BooleanResponse> {
            return EeReportApiFp(configuration).apiV2EeReportSaveOtherInformationPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Save PartB Resubmission Request
         * @param {PartBResubmissionRequestRequestForEe} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSavePartBResubmissionRequestPost(body?: PartBResubmissionRequestRequestForEe, options?: any): AxiosPromise<BooleanResponse> {
            return EeReportApiFp(configuration).apiV2EeReportSavePartBResubmissionRequestPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Save External Examiner Report - Specific Power Money Responses
         * @param {EeReportSpecificPowerMoneyRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSaveSpecificPowerMoneyPost(body?: EeReportSpecificPowerMoneyRequest, options?: any): AxiosPromise<BooleanResponse> {
            return EeReportApiFp(configuration).apiV2EeReportSaveSpecificPowerMoneyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary External Examiner | Submit External Examiner Report
         * @param {EeReportSubmitRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EeReportSubmitEeReportPost(body?: EeReportSubmitRequest, options?: any): AxiosPromise<BooleanResponse> {
            return EeReportApiFp(configuration).apiV2EeReportSubmitEeReportPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EeReportApi - object-oriented interface
 * @export
 * @class EeReportApi
 * @extends {BaseAPI}
 */
export class EeReportApi extends BaseAPI {
    /**
     * 
     * @summary External Examiner | Returns true when a form is successfully closed
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportClosePost(body?: ComplianceFormRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportClosePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact  | Extend the current Form Status
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportExtendFormStatusPost(body?: ComplianceFormRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportExtendFormStatusPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Returns EE Report - Breaches
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportGetBreachesPost(body?: ComplianceFormRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportGetBreachesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Returns EE Report - Controlled Money
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportGetControlledMoneyPost(body?: ComplianceFormRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportGetControlledMoneyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Returns EE Report - Declaration
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportGetDeclarationPost(body?: ComplianceFormRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportGetDeclarationPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Returns EE Report Form Status
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportGetFormStatusComplianceFormIdGet(complianceFormId: number, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportGetFormStatusComplianceFormIdGet(complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Returns EE Report - General Trust Money
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportGetGeneralTrustMoneyPost(body?: ComplianceFormRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportGetGeneralTrustMoneyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Returns EE Report - Investment Money
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportGetInvestmentMoneyPost(body?: ComplianceFormRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportGetInvestmentMoneyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Returns EE Report - Other Information
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportGetOtherInformationPost(body?: ComplianceFormRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportGetOtherInformationPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Returns EE Report - Overview
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportGetOverviewPost(body?: ComplianceFormRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportGetOverviewPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Returns EE Report - Specific Power Money
     * @param {ComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportGetSpecificPowerMoneyPost(body?: ComplianceFormRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportGetSpecificPowerMoneyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact  | Kick out the current Form Status
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportKickOutFormStatusComplianceFormIdGet(complianceFormId: number, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportKickOutFormStatusComplianceFormIdGet(complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Save External Examiner Report - Breaches
     * @param {EeReportBreachRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportSaveBreachesPost(body?: EeReportBreachRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportSaveBreachesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Save External Examiner Report - General Controlled Money Responses
     * @param {EeReportControlledMoneyRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportSaveControlledMoneyPost(body?: EeReportControlledMoneyRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportSaveControlledMoneyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Save External Examiner Report - Declaration
     * @param {EeReportDeclarationRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportSaveDeclarationPost(body?: EeReportDeclarationRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportSaveDeclarationPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Save External Examiner Report - General Trust Money Responses
     * @param {EeReportGeneralTrustMoneyRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportSaveGeneralTrustMoneyPost(body?: EeReportGeneralTrustMoneyRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportSaveGeneralTrustMoneyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Save External Examiner Report - General Controlled Money Responses
     * @param {EeReportInvestmentMoneyRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportSaveInvestmentMoneyPost(body?: EeReportInvestmentMoneyRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportSaveInvestmentMoneyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Save External Examiner Report - Other Information Responses
     * @param {EeReportOtherInformationRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportSaveOtherInformationPost(body?: EeReportOtherInformationRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportSaveOtherInformationPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Save PartB Resubmission Request
     * @param {PartBResubmissionRequestRequestForEe} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportSavePartBResubmissionRequestPost(body?: PartBResubmissionRequestRequestForEe, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportSavePartBResubmissionRequestPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Save External Examiner Report - Specific Power Money Responses
     * @param {EeReportSpecificPowerMoneyRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportSaveSpecificPowerMoneyPost(body?: EeReportSpecificPowerMoneyRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportSaveSpecificPowerMoneyPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary External Examiner | Submit External Examiner Report
     * @param {EeReportSubmitRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EeReportApi
     */
    public apiV2EeReportSubmitEeReportPost(body?: EeReportSubmitRequest, options?: any) {
        return EeReportApiFp(this.configuration).apiV2EeReportSubmitEeReportPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
